import { networkCall } from "../../../../../util/network-call/network-call";

export const StudentCourseListLoader = async () => {

    const getCoursesResponse = await networkCall('/courses');

    return { getCoursesResponse };

};